import { Outlet } from 'react-router-dom'

import Fifthgrade_k5_subjects from './fifthgrade_k5_subjects.jsx';
import TopNavbar from '../../components/TopNavbar.jsx';


const Fifthgrade_k5 = ( ) => {
 
  return (
    <>
   
   
  <TopNavbar />
  <Fifthgrade_k5_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Fifthgrade_k5;